module.exports = __webpack_public_path__ + "media/images/ibu__icon__back-a731c82e4042d30d9148d7835a86eb20.svg";